import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

// Daniel Schulz
// Berliner Sparkasse
// IBAN: DE 73100500001061629305
// BIC: BELADEBEXXX
// Paypal: danielschulz@posteo.de

// Beneficiary: Non-Government Оrganization ‘Docudays’

// Beneficiary’s bank: UKRSIBBANK
// Bank Address: Andriivska 2/12, Kyiv, Ukraine
// IBAN: UA413510050000026009878934461
// SWIFT code: KHABUA2K
// Account currency: EUR

// Intermediary Financial Institution
// Swift code: BNPAFRPP
// Bank name: BNP PARIBAS SA, Paris, France
// Bank address: 16, Boulevard Des Italiens 75009 Paris (France)

// Payment purpose:  charity donation in connection with the war

const card = (
    <CardContent>
      <Typography sx={{ fontSize: 20 }} color="text.secondary" gutterBottom>
        Account currency: EUR
      </Typography>
      <Typography sx={{ fontSize: 20 }} color="text.secondary">
        Beneficiary: Non-Government Оrganization ‘Docudays’
      </Typography>
      <Typography variant="h6" component="div">
        Beneficiary’s bank: UKRSIBBANK
      </Typography>
      <Typography variant="h6" component="div">
        Bank Address: Andriivska 2/12, Kyiv, Ukraine
      </Typography>
      <Typography variant="h6" component="div">
        IBAN: UA413510050000026009878934461
      </Typography>
      <Typography variant="h6" component="div" gutterBottom>
        SWIFT code: KHABUA2K
      </Typography>
      <Typography sx={{ fontSize: 20 }} color="text.secondary" gutterBottom>
        Intermediary Financial Institution
      </Typography>
      <Typography variant="h6" component="div">
        SWIFT code: BNPAFRPP
      </Typography>
      <Typography variant="h6" component="div">
        Bank name: BNP PARIBAS SA, Paris, France
      </Typography>
      <Typography variant="h6" component="div" gutterBottom>
        Bank address: 16, Boulevard Des Italiens 75009 Paris (France)
      </Typography>
      <Typography sx={{ fontSize: 20 }} color="text.secondary">
      Payment purpose:  charity donation in connection with the war
      </Typography>
    </CardContent>
);

const card2 =
    <CardContent>
      <Typography sx={{ fontSize: 20 }} color="text.secondary" gutterBottom>
        Account currency: USD
      </Typography>
  <Typography sx={{ fontSize: 20 }} color="text.secondary" gutterBottom>
    Beneficiary: Non-Government Оrganization ‘Docudays’
  </Typography>
  <Typography variant="h6" component="div">
    Beneficiary’s bank: UKRSIBBANK
  </Typography>
  <Typography variant="h6" component="div">
    Bank Address: Andriivska 2/12, Kyiv, Ukraine
  </Typography>
  <Typography variant="h6" component="div">
    IBAN: UA153510050000026000878934459
  </Typography>
  <Typography variant="h6" component="div" gutterBottom>
    SWIFT code: BNPAUS3N
  </Typography>
  <Typography sx={{ fontSize: 20 }} color="text.secondary" gutterBottom>
    Intermediary Financial Institution
  </Typography>
  <Typography variant="h6" component="div">
    SWIFT code: BNPAFRPP
  </Typography>
  <Typography variant="h6" component="div" gutterBottom>
    Bank name: BNP PARIBAS U.S.A. - New York Branch
  </Typography>
  <Typography sx={{ fontSize: 20 }} color="text.secondary">
    Payment purpose:  charity donation in connection with the war
  </Typography>
</CardContent>

export default function OutlinedCard() {
  return (
    <Box sx={{ minWidth: 275 }}>
      <Card variant="outlined">{card}</Card>
      <Card  sx={{mt: 2}} variant="outlined">{card2}</Card>
    </Box>
  );
}